import { render, staticRenderFns } from "./send-resupply.modal.vue?vue&type=template&id=2a4a1b22&scoped=true"
import script from "./send-resupply.modal.vue?vue&type=script&lang=js"
export * from "./send-resupply.modal.vue?vue&type=script&lang=js"
import style0 from "./send-resupply.modal.vue?vue&type=style&index=0&id=2a4a1b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a1b22",
  null
  
)

export default component.exports